var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-xs-12" },
    [
      _c("datatable", {
        attrs: {
          "table-class": "table table-striped table-bordered",
          "ajax-url": _vm.url,
          columns: _vm.columns
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31920f3e", { render: render, staticRenderFns: staticRenderFns })
  }
}